import { TableCell } from '@mui/material'

export interface ItemTotalCellEstimateRangeProps {
  className?: string
}

const ItemTotalCellEstimateRange = ({
  className,
}: ItemTotalCellEstimateRangeProps) => <TableCell className={className} />

export default ItemTotalCellEstimateRange
